import { TFunction } from "i18next";
import * as yup from "yup";
import { InferType } from "yup";
import {
  SETTING_APPLICATIONS,
  SETTING_VALUE_TYPES,
  SettingValueType,
} from "@/domain/settingCatalog.interface";
import { parseSettingValue } from "@/utils/settingValue";

const settingValidationSchema = (t: TFunction) =>
  yup.object().shape({
    product: yup.string().required("This field is required"),
    application: yup
      .string()
      .required("This field is required")
      .oneOf([...SETTING_APPLICATIONS], "Invalid application"),
    module: yup.string().required("This field is required"),
    section: yup.string().required("This field is required"),
    name: yup
      .string()
      .required("This field is required")
      .max(200, t("validations.max_length", { count: 200 })),
    description: yup
      .string()
      .max(1000, t("validations.max_length", { count: 1000 }))
      .default(""),
    type: yup
      .string()
      .required("This field is required")
      .oneOf([...SETTING_VALUE_TYPES], "Invalid type"),
    // Validated against the chosen `type`: numbers must parse, booleans must be
    // true/false, object/array must be valid JSON of the right shape.
    defaultValue: yup
      .string()
      .default("")
      .test("valid-by-type", "Invalid value", function (value) {
        const { type } = this.parent as { type: SettingValueType };
        const result = parseSettingValue(type, value ?? "");
        return result.ok ? true : this.createError({ message: result.error });
      }),
    active: yup
      .string()
      .oneOf(["true", "false"], "Invalid value")
      .default("true"),
  });

export type SettingFormData = InferType<
  ReturnType<typeof settingValidationSchema>
>;

export default settingValidationSchema;
